import React, { useEffect } from 'react';
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { LoginPage } from '../pages/auth';
import { PagesWrapper } from '@/components/ui/shared';
import Dashboard from '../components/DashboardPage';
import { userService } from '../_services';

var _hsq = window._hsq = window._hsq || [];

function HomePage() {
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        // Set localStorage items
        localStorage.setItem('Prev_Filter_Status', '-');
        localStorage.setItem('Updated_Filter_Status', '-');
        localStorage.setItem('Page_Path', '/dashboard');

        // Setup page view tracking
        const timer = setTimeout(() => {
            sendPageView(location);
        }, 1200);

        // Listen for route changes
        const unlisten = history.listen((loc) => {
            sendPageView(loc);
        });

        return () => {
            clearTimeout(timer);
            unlisten();
        };
    }, [history, location]);


    const sendPageView = (loc) => {
        // Note: Page title is now managed by TitleManager in App.js
        _hsq.push(['setPath', loc.pathname]);
        _hsq.push(['trackPageView']);
    };

    // Check if user is logged in
    try {
        if (userService.Check_LoggedIn_Status() === 'Login') {
            return <Redirect to="/login" />;
        }
    } catch (error) {
        // Silent fail
    }

    // Check localStorage for user
    const userStr = localStorage.getItem('user');
    const sessionEndedHold = userService.isSessionEndedHoldActive();

    if ((!userStr || userStr === "" || userStr === "{}") && !sessionEndedHold) {
        return <Route path="/login" component={LoginPage} />;
    }

    if ((!userStr || userStr === "" || userStr === "{}") && sessionEndedHold) {
        return (
            <PagesWrapper>
                <div className="min-h-[50vh]" aria-hidden />
            </PagesWrapper>
        );
    }

    return (
        <PagesWrapper>
            <Dashboard />
        </PagesWrapper>
    );
}

export default HomePage;
export { HomePage };
